// extracted by mini-css-extract-plugin
export var documentation = "_h8-1";
export var menu = "_h8-0";